import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import useSWR, {SWRConfiguration} from 'swr';
import useSWRMutation, {SWRMutationConfiguration} from 'swr/mutation';
import {WritePreparation} from './types';

export function fetchWritePreparation(
  id?: string | number,
  SWRConfig?: SWRConfiguration<WritePreparation>,
) {
  return useSWR<WritePreparation>(
    `/api/v1/write_preparation/${id}/`,
    (url) => letrusAPI(url).then((res) => res.data),
    {revalidateOnFocus: false, shouldRetryOnError: false, ...SWRConfig},
  );
}

export function updateWritePreparation(
  SWRConfig?: SWRMutationConfiguration<Partial<WritePreparation>, unknown>,
) {
  return useSWRMutation<
    Partial<WritePreparation>,
    unknown,
    string,
    Partial<WritePreparation>
  >(
    '/api/v1/write_preparation/',
    (_, {arg}) => {
      const {id, ...payload} = arg;
      return letrusAPI(`/api/v1/write_preparation/${id}/`, {
        method: 'patch',
        data: payload,
      })
        .then((res) => res.data?.results)
        .catch(() => {});
    },
    SWRConfig,
  );
}

export function finishWritePreparation(
  SWRConfig?: SWRMutationConfiguration<null, unknown>,
) {
  return useSWRMutation<null, unknown, string, {id?: string | number}>(
    '/api/v1/write_preparation/',
    (_, {arg}) => {
      const {id} = arg;
      return letrusAPI(
        `/api/v1/write_preparation/${id}/finish_write_preparation/`,
        {
          method: 'post',
        },
      )
        .then((res) => res.data?.results)
        .catch(() => {});
    },
    SWRConfig,
  );
}
